<template>
    <div v-if="boxStyle === 'full'">
        <router-link :to="{ name: 'ProductDetails', params: { slug: $route.params.slug || $store.getters['auth/currentUserShopSlug'], productSlug: productDetails.slug } }" class="text-reset d-block lh-0 text-center">
            <div class="h-300px" style="overflow: hidden">
                <img :src="productDetails.thumbnail_image" :alt="productDetails.name" @error="imageFallback($event)" class="border" />
            </div>
        </router-link>
    </div>

    <div
        v-else
        :class="[
            boxStyle == 'two' ? 'product-box-two' : boxStyle == 'three' ? 'product-box-three' : boxStyle == 'four' ? 'product-box-four' : 'product-box-one',
        ]"
    >
        <div v-if="isLoading">
            <v-skeleton-loader type="image" :height="boxStyle == 'two' ? '70' : boxStyle == 'three' ? '150' : boxStyle == 'four' ? '130' : '310'" />
        </div>
        <div :class="['overflow-hidden', { 'rounded border': !noBorder }]" v-else>
            <v-row align="center" no-gutters :class="[{ 'flex-nowrap': boxStyle != 'one' }]">
                <v-col :cols="boxStyle == 'one' ? '12' : 'auto'" class="flex-shrink-0">
                    <div class="position-relative">
                        <div v-if="discount > 0 && boxStyle != 'two'" class="discount-badge">{{ $t('off') }} {{ discount }}%</div>
                        <div class="pbox-badges">
                            <span v-if="productDetails.is_hot" class="pbox-badge pbox-badge--hot">HOT</span>
                            <span v-if="productDetails.is_new" class="pbox-badge pbox-badge--new">NEW</span>
                            <span v-if="productDetails.is_event" class="pbox-badge pbox-badge--event">EVENT</span>
                        </div>
                        <router-link :to="{ name: 'ProductDetails', params: { slug: $route.params.slug || $store.getters['auth/currentUserShopSlug'], productSlug: productDetails.slug } }" class="text-reset d-block lh-0 text-center">
                            <img
                                :src="productDetails.thumbnail_image"
                                :alt="productDetails.name"
                                @error="imageFallback($event)"
                                :class="[
                                    'img-fit',
                                    boxStyle == 'two' ? 'size-70px' : boxStyle == 'three' ? 'size-150px' : boxStyle == 'four' ? 'size-130px' : 'h-180px',
                                ]"
                            />
                        </router-link>
                    </div>
                </v-col>
                <v-col :cols="boxStyle == 'one' ? '12' : null" class="minw-0 flex-shrink-0">
                    <div :class="['px-3 d-flex flex-column', boxStyle == 'two' ? 'py-1' : 'py-2']">
                        <div v-show="$store.getters['auth/isShowPrice']">
                        <div :class="[boxStyle == 'two' ? 'order-2 fs-14 lh-1' : 'fs-16 mb-2']" v-if="productDetails.base_discounted_price > 0">
                            <template v-if="productDetails.base_price > productDetails.base_discounted_price">
                                <del class="opacity-40">{{ format_price(productDetails.base_price) }}</del>
                                <span class="fw-700">{{ format_price(productDetails.base_discounted_price) }}</span>
                            </template>
                            <template v-else>
                                <span class="fw-700">{{ format_price(productDetails.base_discounted_price) }}</span>
                            </template>
                        </div>
                        </div>
                        <h5 :class="['opacity-80 fw-400 mb-2 lh-1-6', boxStyle == 'two' ? 'text-truncate fs-12' : 'fs-13']">
                            <router-link :to="{ name: 'ProductDetails', params: { slug: $route.params.slug || $store.getters['auth/currentUserShopSlug'], productSlug: productDetails.slug } }" class="text-reset">
                                <span class="fs-15 fw-700">{{ productDetails.name }}</span>
                            </router-link>

                            <!-- <div v-if="productDetails.product_section == 'printing' && productDetails.option_summary" class="option-summary mt-1" v-html="productDetails.option_summary"></div>
                            <div v-if="productDetails.meta_description" class="meta-desc mt-1">{{ productDetails.meta_description }}</div> -->
                        </h5>

                        <!-- 리뷰 정보 표시: settings.reviews=1일 때만 노출 -->
                        <div v-if="productDetails.review_summary && generalSettings.reviews == 1" class="review-info mt-1 mb-2">
                            <v-rating
                                background-color=""
                                empty-icon="las la-star"
                                full-icon="las la-star active"
                                half-icon="las la-star half"
                                hover
                                half-increments
                                readonly
                                size="14"
                                length="5"
                                :value="productDetails.review_summary.average"
                            ></v-rating>
                            <span class="review-text ms-1">
                                {{ (productDetails.review_summary.average || 0).toFixed(1) }}
                                ({{ productDetails.review_summary.total_count }})
                            </span>
                        </div>
                        <div class="d-flex align-center" v-if="boxStyle != 'two' && productDetails.product_section != 'printing'">
                            <div :class="[boxStyle == 'three' || boxStyle == 'four' ? 'me-3' : 'flex-grow-1 me-1']">
                                <template v-if="productDetails.stock">
                                    <button
                                        class="text-reset py-1 lh-1 align-center d-flex"
                                        @click="showAddToCartDialog({ status: true, slug: productDetails.slug })"
                                    >
                                        <i class="la la-shopping-cart fs-20 ts-05 me-1"></i>
                                        <span class="fw-700 fs-13">{{ $t('buy_now') }}</span>
                                    </button>
                                    <!-- <span v-else-if="!productDetails.is_variant && isThisInCart(productDetails.variations[0].id)" class="d-flex align-center">
                                        <button class="btn-xxs size-20px d-inline-flex align-center justify-center" @click="updateCart('minus',findCartItemByVariationId(productDetails.variations[0].id).cart_id)" type="button">
                                            <i class="las la-minus fs-16 ts-05"></i>
                                        </button>
                                        <span class="mx-4">{{ findCartItemByVariationId(productDetails.variations[0].id).qty }}</span>
                                        <button class="btn-xxs size-20px d-inline-flex align-center justify-center" @click="updateCart('plus',findCartItemByVariationId(productDetails.variations[0].id).cart_id)" type="button">
                                            <i class="las la-plus fs-16 ts-05"></i>
                                        </button>
                                    </span>
                                    <button class="py-1 lh-1 align-center d-flex" v-else @click="addCart" type="button">
                                        <i class="la la-shopping-cart fs-20 ts-05 me-1"></i>
                                        <span class="fw-700 fs-13">Add to Cart</span>
                                    </button> -->
                                </template>
                                <template v-else>
                                    <span class="fw-700 fs-13 opacity-60">{{ $t('out_of_stock') }}</span>
                                </template>
                            </div>
                            <div>
                                <template v-if="isThisWishlisted(productDetails.id)">
                                    <button class="primary--text pa-1 lh-1" @click="removeFromWishlist(productDetails.id)" type="button">
                                        <i class="la la-heart ts-02 fs-18"></i>
                                    </button>
                                </template>
                                <template v-else>
                                    <button class="primary--text pa-1 lh-1" @click="addNewWishlist(productDetails.id)" type="button">
                                        <i class="la la-heart-o ts-02 fs-18"></i>
                                    </button>
                                </template>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions, mapMutations } from 'vuex';
    export default {
        props: {
            isLoading: { type: Boolean, required: true, default: true },
            boxStyle: { type: String, default: 'one' },
            noBorder: { type: Boolean, default: false },
            productDetails: { type: Object, required: true, default: {} },
        },
        data: () => ({}),
        computed: {
            ...mapGetters('app', ['generalSettings']),
            ...mapGetters('wishlist', ['isThisWishlisted']),
            ...mapGetters('cart', ['isThisInCart', 'findCartItemByVariationId']),
            discount() {
                return this.discount_percent(this.$props.productDetails.base_price, this.$props.productDetails.base_discounted_price);
            },
        },
        methods: {
            ...mapActions('wishlist', ['addNewWishlist', 'removeFromWishlist']),
            ...mapActions('cart', ['addToCart', 'updateQuantity']),
            ...mapMutations('auth', ['showAddToCartDialog']),
            addCart() {
                if (!this.$props.productDetails.is_variant) {
                    this.addToCart({
                        variation_id: this.$props.productDetails.variations[0].id,
                        qty: this.$props.productDetails.min_qty,
                    });
                }
            },
            updateCart(type, cart_id) {
                this.updateQuantity({
                    type: type,
                    cart_id: cart_id,
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
.pbox-badges {
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.pbox-badge {
    display: inline-block;
    font-size: 11px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 20px;
    line-height: 1.4;
    letter-spacing: 0.5px;
    &--hot {
        background: #ff4500;
        color: #fff;
    }
    &--new {
        background: #0057ff;
        color: #fff;
    }
    &--event {
        background: #e65c00;
        color: #fff;
    }
}
    .option-summary {
        font-size: 12px;
        opacity: 0.7;
        line-height: 1.5;
    }

    .meta-desc {
        font-size: 12px;
        opacity: 0.6;
        line-height: 1.5;
    }

    .review-info {
        display: flex;
        align-items: center;
    }

    .review-text {
        font-size: 12px;
        color: #666;
    }

    .review-info {
        ::v-deep .v-rating button {
            width: 14px !important;
            height: 14px !important;
            margin-right: 2px !important;
        }
    }
</style>

